import React from 'react'
import Main from '../components/Main'
import Content1 from '../components/Content1'
import Services from '../components/Services'
import Content2 from '../components/Content2'
import Testimonials from '../components/Testimonials'

export default function Home() {
  return (
    <>
       <Main/>
       <Content1/>
       <Services/>
       <Content2/>
       <Testimonials/>
    </>
  )
}
